import { FC } from 'react'
import { getTrackBackground, Range } from 'react-range'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../app/hooks'
import { setVolume, selectVolume } from '../data/articleSlice'

interface Props {
    foregroundColor: string
    backgroundColor: string
}

const VolumeSlider: FC<Props> = ({ foregroundColor, backgroundColor }) => {
    const dispatch = useDispatch()
    const volume = useAppSelector(selectVolume)
    const values = [volume]

    return (
        <Range
            step={0.01}
            min={0}
            max={1}
            values={values}
            onFinalChange={values => dispatch(setVolume(values[0]))}
            onChange={values => dispatch(setVolume(values[0]))}
            renderTrack={({ props, children }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        height: '8px',
                        width: '100%',
                        padding: '12px 2px 2px 2px', // Padding added here to increase seekbar hitbox - Change background colour to visualise.
                        margin: '-12px -2px -2px -2px', // Padding pushes seekbar over so negative margin added to negate.
                        backgroundColor: 'transparent', // Change from 'transparent' to see hitbox padding
                        borderRadius: '8px',
                        zIndex: 1,
                    }}>
                    <div
                        ref={props.ref}
                        style={{
                            height: '8px',
                            width: '100%',
                            borderRadius: '4px',
                            background: getTrackBackground({
                                values: values,
                                colors: [foregroundColor, backgroundColor],
                                min: 0,
                                max: 1,
                            }),
                        }}>
                        {children}
                    </div>
                </div>
            )}
            renderThumb={({ props }) => (
                <div
                    {...props}
                    style={{
                        ...props.style,
                        height: '0px',
                        width: '0px',
                        backgroundColor: 'red',
                    }}
                />
            )}
        />
    )
}

export default VolumeSlider
